import React from 'react';
import { Check, X } from 'lucide-react';
import { canTrademark, cannotTrademark } from '../data/mock';

const Eligibility = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-emerald-100 text-emerald-800 rounded-full text-xl font-semibold">
            Eligibility
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Know What's Protectable
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Understanding what qualifies for trademark protection is essential. Here's a guide to items that can and cannot be trademarked.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-emerald-200">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center">
                <Check className="w-6 h-6 text-emerald-600" />
              </div>
              What You Can Trademark
            </h3>
            <ul className="space-y-4">
              {canTrademark.map((item, index) => (
                <li key={index} className="flex items-start gap-3 group">
                  <div className="flex-shrink-0 w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center mt-0.5 group-hover:scale-110 transition-transform">
                    <Check className="w-4 h-4 text-emerald-600" />
                  </div>
                  <span className="text-gray-700 leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-red-200">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                <X className="w-6 h-6 text-red-600" />
              </div>
              What You Can't Trademark
            </h3>
            <ul className="space-y-4">
              {cannotTrademark.map((item, index) => (
                <li key={index} className="flex items-start gap-3 group">
                  <div className="flex-shrink-0 w-6 h-6 bg-red-100 rounded-full flex items-center justify-center mt-0.5 group-hover:scale-110 transition-transform">
                    <X className="w-4 h-4 text-red-600" />
                  </div>
                  <span className="text-gray-700 leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Eligibility;